import styled from "styled-components";
import { Draggable, DraggableLocation } from "@hello-pangea/dnd";
import { IDraggableAlignmentResultSection, IResource, ResourceType } from "store/types";
import { Grid } from "@mui/material";
import { ResourceButtons } from "./ResourceButtons";
import { capitalize, upperCase } from "lodash";
import { Aligned, HiddenChip } from "components/Layout";

const Container = styled.div<{ isdragging?: string; isreadonly?: string }>`
  border: ${(props) =>
    props.isreadonly === "true"
      ? "1px solid #eeeeee"
      : props.isdragging === "true"
      ? "2px solid #252525"
      : "1px solid #999999"};
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 8px;
  transition: background-color 0.2s ease;
  background-color: ${(props) => (props.isdragging === "true" ? "#eeeeee" : "#FAFAFA")};
`;

export const Type = styled.p`
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 13px;
  font-weight: 400;
  color: "#6C6C6C";
`;

export const Label = styled.p`
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 400;
  color: "#414141";
`;

interface IProps {
  index: any;
  resource: IResource;
  onMoveResourceViaMenu: (source: DraggableLocation, destination: DraggableLocation, draggableId: string[]) => any;
  onExcludeResourceViaMenu?: (source: DraggableLocation, draggableId: string[]) => any;
  sidebar?: boolean;
  state: any;
  section: IDraggableAlignmentResultSection;
}

export const Resource = ({
  index,
  resource,
  onMoveResourceViaMenu,
  onExcludeResourceViaMenu,
  sidebar,
  state,
  section,
}: IProps) => {
  return (
    <Draggable draggableId={resource.uid} index={index} isDragDisabled={resource.readOnly}>
      {(provided, snapshot) => (
        <Container
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          isdragging={`${snapshot.isDragging}`}
          isreadonly={`${resource.readOnly}`}
        >
          <Grid container>
            <Grid item xs={!sidebar ? 8 : 8} style={{ display: "flex", alignItems: "center", justifyContent: "left" }}>
              <Aligned>
                <div style={{ paddingLeft: "6px" }}>
                  <img style={{ height: "16px" }} src={resource.iconUrl} alt={resource.type} title={resource.type} />
                </div>
                <div style={{ paddingLeft: "12px" }}>
                  <Type>
                    <Aligned>
                      {resource.type === ResourceType.URL ? upperCase(resource.type) : capitalize(resource.type)}{" "}
                      {!resource.visible && (
                        <>
                          &nbsp;
                          <HiddenChip label="Hidden" />
                        </>
                      )}
                    </Aligned>
                  </Type>
                  <Label>{resource.description}</Label>
                </div>
              </Aligned>
            </Grid>
            {!sidebar && (
              <>
                <Grid
                  item
                  xs={2}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "left",
                    paddingLeft: "18px",
                  }}
                >
                  <Label>{resource.originalSectionName}</Label>
                </Grid>
              </>
            )}
            <Grid item xs={!sidebar ? 2 : 4} style={{ display: "flex", justifyContent: "right", alignItems: "center" }}>
              <ResourceButtons
                section={section}
                resource={resource}
                onMove={onMoveResourceViaMenu}
                onExclude={onExcludeResourceViaMenu}
                state={state}
              />
            </Grid>
          </Grid>
        </Container>
      )}
    </Draggable>
  );
};
